var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _g, _path8, _path9, _path10, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9c34c2",
    d: "M54,20v24c0,2.25-0.74,4.32-2,5.99V50c-1.69,2.24-4.29,3.75-7.25,3.97C44.51,53.99,44.25,54,44,54H20 c-5.52,0-10-4.48-10-10V20c0-0.25,0.01-0.51,0.03-0.75c0.22-2.96,1.73-5.56,3.97-7.25h0.01c1.67-1.26,3.74-2,5.99-2h24 C49.52,10,54,14.48,54,20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bc379c",
    d: "M54,29.36V44c0,2.25-0.74,4.32-2,5.99V50c-1.69,2.24-4.29,3.75-7.25,3.97 C44.51,53.99,44.25,54,44,54H20c-5.52,0-10-4.48-10-10V20c0-0.25,0.01-0.51,0.03-0.75c0.22-2.96,1.73-5.56,3.97-7.25h0.01 c1.67-1.26,3.74-2,5.99-2h14.64C42.93,14.29,49.71,21.07,54,29.36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd3975",
    d: "M52,49.99V50c-1.69,2.24-4.29,3.75-7.25,3.97C44.51,53.99,44.25,54,44,54H20c-5.52,0-10-4.48-10-10 V20c0-0.25,0.01-0.51,0.03-0.75c0.22-2.96,1.73-5.56,3.97-7.25h0.01C34.99,12.01,51.99,29.01,52,49.99z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd3c4f",
    d: "M45,50c0,1.34-0.09,2.67-0.25,3.97C44.51,53.99,44.25,54,44,54H20c-5.52,0-10-4.48-10-10V20 c0-0.25,0.01-0.51,0.03-0.75C11.33,19.09,12.66,19,14,19C31.12,19,45,32.88,45,50z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe6d42",
    d: "M38,50c0,1.36-0.11,2.7-0.34,4H20c-5.52,0-10-4.48-10-10V26.34c1.3-0.23,2.64-0.34,4-0.34 C27.25,26,38,36.75,38,50z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9d36",
    d: "M32,50c0,1.37-0.15,2.71-0.46,4H20c-5.52,0-10-4.48-10-10V32.46c1.29-0.31,2.63-0.46,4-0.46 C23.94,32,32,40.06,32,50z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffce29",
    d: "M25,50c0,1.41-0.27,2.76-0.75,4H20c-5.52,0-10-4.48-10-10v-4.25c1.24-0.48,2.59-0.75,4-0.75 C20.08,39,25,43.92,25,50z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 20,
    ry: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31,15c2.761,0,5-2.238,5-5H20c-5.523,0-10,4.477-10,10v22c2.761,0,5-2.238,5-5V20 c0-2.757,2.243-5,5-5H31z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,44V22c-2.761,0-5,2.238-5,5v17c0,2.757-2.243,5-5,5H33c-2.761,0-5,2.238-5,5h16 C49.523,54,54,49.523,54,44z",
    opacity: 0.15
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14,21.5c-0.829,0-1.5-0.671-1.5-1.5c0-4.136,3.364-7.5,7.5-7.5c0.829,0,1.5,0.671,1.5,1.5 s-0.671,1.5-1.5,1.5c-2.481,0-4.5,2.019-4.5,4.5C15.5,20.829,14.829,21.5,14,21.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.5,48h-15c-4.687,0-8.5-3.813-8.5-8.5v-15c0-4.687,3.813-8.5,8.5-8.5h15 c4.687,0,8.5,3.813,8.5,8.5v15C48,44.187,44.187,48,39.5,48z M24.5,19c-3.033,0-5.5,2.467-5.5,5.5v15c0,3.033,2.467,5.5,5.5,5.5h15 c3.033,0,5.5-2.467,5.5-5.5v-15c0-3.033-2.467-5.5-5.5-5.5H24.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,40c-4.411,0-8-3.589-8-8s3.589-8,8-8s8,3.589,8,8S36.411,40,32,40z M32,27c-2.757,0-5,2.243-5,5 s2.243,5,5,5s5-2.243,5-5S34.757,27,32,27z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 23.5,
    r: 2,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.d1fc87cd9e46883f876804a1be700a98.svg";
export { ForwardRef as ReactComponent };